import React, { PureComponent, Fragment } from 'react';
import {
  Cascader,
  formCreator,
  FormItem,
  ValidationField,
  Input,
  Button,
  Row,
  Col,
  Icon,
  Modal,
  Table,
  Tag,
  Pagination,
  Notice,
  Radio
} from 'neatui';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import md5 from 'blueimp-md5';
import CryptoJS from 'crypto-js';

import nosConfig from 'Util/nosConfig';
import ajax from "../util/ajax";
import {
  QUESTION_TYPE,
  TOPIC_ID_MAP,
  UN_LINE_QUESTION_TYPE,
  WARNING_ACCOUNT_QUESTION_TYPE,
  BRAND_NUMBER_RELATED_TYPE,
} from './const';
import PlagiarizeLink from './PlagiarizeLink';
import Drawer from '../../common/Drawer';
import QuestionItem from './QuestionItem';
import './style.module.scss';
import {historyPush} from "../util/publish";

const MAX_FILE = 5;
const HOT_LIST = '/customer/articleListByElephont.do';
// const TOPIC_ID = '00019AD7';
const SIZE = 100;
// const ARTICLE_AUDITED = 'MAJTAGF813H6FN';
const ARTICLE_AUDITED = 'SUBTAGJ8CK7QPL';
const PLAGIARIZE = 'SUBTAGJ8CKAU6F';
const USER_NAME = 'SUBTAGJ8CKBBH8';
const RIGHTS_NAME = 'MAJTAGJ8CKEQQT';
const AUTH_NAME = 'SUBTAGJ8CL2QD4';
// const VIDIEO_AUDITED = 'MAJTAGF813HM92';
const VIDIEO_AUDITED = 'SUBTAGJ8CK86TB';
const UNAUDITED_ARTICLES = 'customer/auditQuery.do?contentType=1&wemediaId=W5470498096488496069';
const UNAUDITED_VIDIEOS = 'customer/auditQuery.do?contentType=2&wemediaId=W5470498096488496069';

const ACCOUNT_STATUS_TO_QUESTION_TYPE = {
  1: UN_LINE_QUESTION_TYPE,
  2: QUESTION_TYPE,
  3: UN_LINE_QUESTION_TYPE,
  4: WARNING_ACCOUNT_QUESTION_TYPE,
  7: WARNING_ACCOUNT_QUESTION_TYPE,
  9: WARNING_ACCOUNT_QUESTION_TYPE,
};

const AUTH_CLASSIFY_KEY = `${window.location.hostname}:auth:classify:key_`;

const rules = {
  content: [
    {
      validator(value = '', tagCode) {
        if(tagCode === ARTICLE_AUDITED || tagCode === VIDIEO_AUDITED) {
          return true
        }
        return value.trim().length > 0;
      },
      message: '请输入问题描述',
      join:['tagCode']
    },
    {
      validator(value = '', tagCode) {
        if(tagCode === ARTICLE_AUDITED || tagCode === VIDIEO_AUDITED) {
          return true
        }
        return value.trim().length > 0 && value.trim().length < 500;
      },
      message: '请输入少于500字的问题描述',
      join:['tagCode']
    },
  ],
};

const submitNotice = Notice.create({
  position: 'top',
});
class FeedbackForm extends PureComponent {
  constructor(props) {
    super(props);
  }

  state = {
    files: [],
    videoFiles: [],
    appendixFiles: [],
    questionList: [],
    plagiarizeValue: [],
    feedback: '',
    feedbackId:'',
    feedbackTitle: '',
    feedbackDocId: '',
    isFeedbackListShow: false,
    current:1,
    total:0,
    pageSize:10,
    dataSource: [],
    linkError: true,
    isLastCode: false,
    nameError: false,
    visible: false,
    name: '',
    questionCode: '',
    currentQuestion: {},
    questionInfo: {},
  };



  Pagination = {
    current:this.state.current,
    total:this.state.total,
    pageSize:this.state.pageSize,
    showPer:false,
    scrollToTop:false,
    prev:"前一页",
    next:"后一页",

  }

  // componentDidMount() {
  //   this.updateData();
  // }

  componentDidMount() {
    const { common } = this.props;
    const authClassifyLocalStorageKey = `${AUTH_CLASSIFY_KEY}${common.user.wemediaId}`;
    const authClassifyLocalStorage = localStorage.getItem(authClassifyLocalStorageKey);
    if (authClassifyLocalStorage) {
      const qustionType = JSON.parse(authClassifyLocalStorage).value;
      if (qustionType === 'auth-info') {
        this.setState({
          questionCode: RIGHTS_NAME,
          tagCode: AUTH_NAME,
          isLastCode: true,
        }, () => {
          localStorage.removeItem(authClassifyLocalStorageKey);
        });
      }
    }
  }

  handleOpenDrawer = q => {
    this.setState({
      visible: true,
      currentQuestion: q,
    });
  };

  handleCloseDrawer = () => {
    this.setState({
      visible: false,
    })
  };

  handleCommit = data => {
    const { common, initialize } = this.props;
    const { tagCode,  feedbackId, plagiarizeValue, name } = this.state;
    let other = '';
    // 帐号同名
    if (tagCode === USER_NAME) {
      other = `name:${name}`;
    }
    // 投诉类型为抄袭举报
    if (tagCode === PLAGIARIZE) {
      const urlData = plagiarizeValue.map(item => ({
        plagiarizeValue: item.plagiarizeValue,
        originValue: item.originValue,
      }));
      other = `linkPrefix:${JSON.stringify(urlData)}`;
      if ((data.content + other).length > 1000) {
        submitNotice.show({
          content: '问题描述+填写链接限制1000字以内',
          type: 'warning',
          showClose:false,
          mini: true,
        });
        return;
      }
    }
    if(tagCode === ARTICLE_AUDITED || tagCode === VIDIEO_AUDITED ) {
      return ajax(
        'customer/sendAuditMessage.do',
        {
          method: 'post',
          data: {
              docId:feedbackId,
              contentType: (tagCode === ARTICLE_AUDITED) ? 1 : 2
              }
        },
        res => {
          if(res.code === 1) {
              submitNotice.show({
                  content: (
                        <p>您的反馈已收到，我们将优先审核。</p>
                  ),
                  type: 'success',
                  showClose:false,
                  mini: true,
                  style:{"maxWidth":"360px"}
              });
              initialize();
              this.setState({
                feedback:''
              })
            }
        }
      )
    // eslint-disable-next-line no-else-return
    } else {
      const { files, videoFiles, appendixFiles } = this.state;
      const deviceId = md5(common.user.realUserId);
      const clientId = `${deviceId}_${Date.now()}`;
      const rawData = {
        feedbackType: 1,
        platformType: 5,
        content: `${data.content}${other ? `  ${other}` : ''}`,
        mobileVersion: data.link,
        subTagCode: tagCode,
        mobileSystemVersion: data.contact,
        userAgent: window.navigator.userAgent,
        clientId,
        deviceId,
        feedbackImg: files
          .filter(file => file.url)
          .map(file => file.url)
          .join(','),
        encryptVideo: videoFiles.filter(file => file.url)
          .map(file => file.url)
          .join(','),
        encryptFile: appendixFiles.filter(file => file.url)
          .map(file => file.url)
          .join(',')
      };
      // const key = CryptoJS.enc.Utf8.parse('neteasenewsboard');
      // const encodeRawData = CryptoJS.enc.Utf8.parse(JSON.stringify(rawData));
      // const encryptData = CryptoJS.AES.encrypt(encodeRawData, key, {
      //   mode: CryptoJS.mode.ECB,
      //   padding: CryptoJS.pad.Pkcs7,
      // });
      // const base64Data = CryptoJS.enc.Base64.stringify(encryptData.ciphertext);
      return ajax(
        '/feedback/addFeedback.do',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          // 引入了加密算法则加密否则不加密 // 不需要加密
          data: rawData,
        },
        newData => {
          const { history } = this.props;
          if (newData && newData.code === 1) {
            historyPush(history, '/details/feedback-history');
            // this.props.push('/details/feedback-history');
            initialize();
          }
        },
      );
    }

  };

  updateData = topicIds => ajax(
      HOT_LIST,
      {
        method: 'post',
        data: {
          size: SIZE,
          topicIds,
          pageNo: 1,
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
      newData => {
        if (newData && newData.data) {
          this.setState({
            questionList: newData.data.list,
          });
        }
      },
    );

  // 上传图片
  handleImgChange = e => {
    const {length} = this.state.files;
    const newFiles = Array.from(e.target.files)
      .filter(file => {
        if (!/(gif|png|jpe?g)$/.test(file.type)) {
          Modal.warning({
            title: '提示',
            content: `${file.name || ''}文件类型错误！`,
          });
          return false;
        }
        if (file.size > 5000000) {
          Modal.warning({
            title: '提示',
            content: `${file.name || ''}文件大于5M！`,
          });
          return false;
        }
        return true;
      })
      .slice(0, MAX_FILE - this.state.files.length);
    const keyMap = newFiles.map(file => ({
      key: file.name + parseInt(Math.random() * 100, 10),
      file,
    }));
    this.setState(state => ({
      files: state.files.concat(
        keyMap.map(file => ({
          url: '',
          name: file.file.name,
          loaded: false,
        })),
      ),
    }));
    try {
      e.target.files = null;
    } catch (e) {}
    keyMap.forEach((file, index) => {
      index += length;
      this.uploadVideoAndAppendix(file.file, 'files');
    });
  };

  // 上传视频，格式均支持，支持10MB
  handleVideoChange = e => {
    const { files } = e.target;
    const filename = files[0].name;
    const videoType = filename.substring(filename.lastIndexOf('.') + 1);
    if (!/(wmv|asf|asx|rm|rmvb|mp4|mpg|mpeg|3gp|3g2|mov|m4v|avi|dat|mkv|flv|vob|f4v|swf|mpeg4|ts)/i.test(videoType)) {
      return Modal.warning({
        title: '提示',
        content: '请上传.mp4、.wmv、.flv格式的视频',
      });
    }
    if(files[0].size /1024 > 1024 *10){
      return Modal.warning({
        title: '提示',
        content: '视频最大不能超过10M',
      });
    }
    this.setState(state => ({
      videoFiles: [{
          url: '',
          name: files[0].name,
          loaded: false,
        }],
    }));
    this.uploadVideoAndAppendix(files[0], 'videoFiles')
  }

  // 上传附件，包括word、excel、PDF，支持10MB
  handleAppendixChange = e => {
    const { files } = e.target;
    const filename = files[0].name;
    const appendixType = filename.substring(filename.lastIndexOf('.') + 1);
    if (!/(doc|docx|pdf|xls|xlsx)/i.test(appendixType)) {
      return Modal.warning({
        title: '提示',
        content: '请上传.doc、.docx、.pdf、.xls、.xlsx格式的附件',
      });
    }
    if(files[0].size /1024 > 1024 *10){
      return Modal.warning({
        title: '提示',
        content: '附件最大不能超过10M',
      });
    }
    this.setState(state => ({
      appendixFiles: [{
          url: '',
          name: files[0].name,
          loaded: false,
        }],
    }));
    this.uploadVideoAndAppendix(files[0], 'appendixFiles')
  }

  // 视频库的上传接口（视频、附件用到）
  uploadVideoAndAppendix = (file, type) => {
    const formData = new window.FormData();
      formData.append('file', file);
      const xhr = new window.XMLHttpRequest();
      xhr.open('POST', `//upfile.m.163.com/nos/upload/pub/aes?requireHttps=true`);
      xhr.onload = e => {
        let result = {};
        if (xhr.status === 200) {
          result = JSON.parse(xhr.responseText);
        }
        if (result.status === 1) {
          this.setState(state => {
            const target = state[type].findIndex(f => f.name === file.name);
            if (target < 0) {
              return state;
            }
            state[type][target] = {
              ...state[type][target],
              url: result.url,
              loaded: true,
            };
            return {
              [type]: [...state[type]],
            };
          });
        } else {
          this.setState(state => {
            const target = state[type].findIndex(f => f.key === file.key);
            if (target < 0) {
              return state;
            }
            state[type][target] = {
              ...state[type][target],
              url: '',
              loaded: true,
            };
            return {
              [type]: [...state[type]],
            };
          });
        }
      };
      xhr.onerror = e => {
        this.setState(state => {
          const target = state[type].findIndex(f => f.key === file.key);
          if (target < 0) {
            return state;
          }
          state[type][target] = {
            ...state[type][target],
            url: '',
            loaded: true,
          };
          return {
            [type]: [...state[type]],
          };
        });
      };
      xhr.send(formData);
  }

  handleDelete = (key, type) => () => {
    this.setState(state => ({
      [type]: state[type].filter((value, i) => value.key !== key),
    }));
  };

  handleResetFeedback = () => {
    this.setState({
      feedback:''
    })
  }

  handleChangeName = events => {
    const { target: { value } } = events;
    this.setState({ name: value }, () => {
      const { name } = this.state;
      this.setState({
        nameError: !name,
        name,
      });
    });
  };

  handleChangeType = value => {
    if (value.length === 2) {
      const { updateItemData } = this.props;
      const [key, last] = value;
      updateItemData('tagCode', last);
      const { questionCode } = this.state;
      if (questionCode !== key) {
        this.setState({
          questionCode: key,
        }, () => {
          const topicIds = TOPIC_ID_MAP[key];
          if (topicIds) {
            const index = QUESTION_TYPE.findIndex(item => item.value === key);
            if (index !== -1) {
              this.setState({
                questionInfo: QUESTION_TYPE[index],
              })
            }
            this.updateData(topicIds);
          } else {
            this.setState({
              questionList: [],
            });
          }
        });
      }
    }
    if (value.length < 2) {
      this.setState({
        isLastCode: false,
      })
    }
  };

  handleTagCodeChange = (value, options, isLast) => {
    const { plagiarizeValue, name } = this.state;
    this.setState({
      tagCode: options,
      isLastCode: isLast,
    });
    if(options === ARTICLE_AUDITED || options === VIDIEO_AUDITED) {
      this.handleResetFeedback()
      this.setState({
        current: 1,
        pageSize: 10
      })
      this.props.initialize()
    }

    if(options !== PLAGIARIZE && plagiarizeValue) {
      this.setState({ plagiarizeValue: [], linkError: true });
    }

    if(options !== USER_NAME && name) {
      this.setState({ name: '', nameError: false });
    }
  }

  fetchFeedbackList = () => {
    const { tagCode, current, pageSize } = this.state;
    if(tagCode === ARTICLE_AUDITED || tagCode === VIDIEO_AUDITED) {
      return ajax(
        (tagCode === ARTICLE_AUDITED) ? UNAUDITED_ARTICLES : UNAUDITED_VIDIEOS,
        {
          method:'post',
          data:{
            pageNo:current,
            size:pageSize
          }
        },
        res => {
          if(res.data && res.data.list) {
            this.setState({
              dataSource:res.data.list,
              total:res.data.total
            })
          }
        }
      )
    }
  }

  toggelFeedbackList = status => {
    this.setState({
      isFeedbackListShow:status
    })

    if(status === true) {
      this.fetchFeedbackList()
    }
  }

  handleSwitchFeedbackItem = e => {
    this.setState({
      feedbackTitle: e.target.value,
      feedbackDocId: e.target.dataset.docid
    })
  }

  handlePageChange = pageNo => {
    this.setState({
      current:pageNo
    },() => {this.fetchFeedbackList()})
  }

  isUrl = str => {
    // eslint-disable-next-line max-len
    const v = new RegExp('^(?!mailto:)(?:(?:http|https)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i');
    return v.test(str);
  };

  handleChangePlagiarizeValue = data => {
    let hasEmpty = false;
    data.forEach(item => {
      if (!item.originValue || !item.plagiarizeValue) {
        hasEmpty = true;
      }
      if ((item.originValue && !this.isUrl(item.originValue)) || (item.plagiarizeValue && !this.isUrl(item.plagiarizeValue))) {
        hasEmpty = true;
      }
    });
    this.setState({
      plagiarizeValue: data,
      linkError: hasEmpty,
    })
  };

  render() {
    const { submit, isSubmitting, isInitialized, isValid, common } = this.props;
    const { user } = common;
    const {
      files, videoFiles, appendixFiles, questionList , feedback, tagCode, isFeedbackListShow, feedbackTitle, feedbackDocId,
      dataSource, current, total, pageSize, isLastCode, visible, currentQuestion, questionInfo, questionCode,
      linkError, name, nameError,
    } = this.state;
    const columns = [
        {
           title:'选择内容',
           key:'',
           width:'70%',
           render:(index, record) => {
             const radioItem = <Fragment>
             <Radio
             onChange={this.handleSwitchFeedbackItem}
             checked={feedbackTitle === record.title}
             name="feedbackItem"
             key={record.title}
             value={record.title}
             data-docid={tagCode === ARTICLE_AUDITED ? record.articleId : record.skipId}/>
             <span
             style={{"marginLeft":"2px"}}>
               {record.title}
            </span>
           </Fragment>
             return radioItem;
           }
        },
        {
            title: '',
            key: 'createTime',
            width: '30%',
        }
      ]
    return (
      <Fragment>
        <div styleName="top-tip">为了帐号安全及功能的正常使用，建议您使用Chrome（谷歌浏览器）、搜狗、QQ、Safari浏览器，并升级至最新版本。</div>
        <Row styleName="form-container">
          <Col size="16">
            <div styleName="question-type">
              <div styleName="question-type-label">
                <span styleName="question-type-red">*</span>问题类型
                <span>:</span>
              </div>
              <div>
                {/* 帐号类型位品牌号，则只展示品牌号相关 */}
                {user && user.accountType === 4 ? (
                  <Cascader
                    options={user && user.onlineState
                      ? (BRAND_NUMBER_RELATED_TYPE || [])
                      : UN_LINE_QUESTION_TYPE}
                    onChange={this.handleChangeType}
                    onSelect={this.handleTagCodeChange}
                    placeholder="请选择问题类型"/>
                ) : (
                  <Cascader
                    defaultValue={questionCode !== '' ? [questionCode, tagCode] : undefined}
                    options={user && user.onlineState
                      ? (ACCOUNT_STATUS_TO_QUESTION_TYPE[user.onlineState] || [])
                      : UN_LINE_QUESTION_TYPE}
                    onChange={this.handleChangeType}
                    onSelect={this.handleTagCodeChange}
                    placeholder="请选择问题类型"/>
                )}
              </div>
            </div>
            {!(tagCode === ARTICLE_AUDITED || tagCode === VIDIEO_AUDITED) && <ValidationField
              validateTrigger="onBlur"
              label={
                <Fragment>
                  <span className="red-font">*</span>问题描述
                </Fragment>
              }
              name="content"
              labelLayout={{ size: 4 }}>
              <Input multiline placeholder="请填写问题描述， 将有助于我们解决您的问题" rows="4" />
            </ValidationField>}
            {tagCode === USER_NAME ?
              <FormItem
                styleName="file-uploader"
                labelLayout={{ size: 4 }}
                label={
                  <Fragment>
                    <span className="red-font">*</span>侵权用户名
                  </Fragment>
                }>
                <div>
                  <Input
                    value={name}
                    placeholder="请输入名称"
                    onChange={this.handleChangeName}/>
                  {nameError ? (<div style={{ fontSize: '12px', color: 'red', position: 'absolute', bottom: '-26px', left: '4px' }}>请输入名称</div>) : null}
                </div>
              </FormItem> : null}
            {tagCode === PLAGIARIZE
              ? <PlagiarizeLink
                onChange={this.handleChangePlagiarizeValue}/>
              : null}
            {(tagCode === ARTICLE_AUDITED || tagCode === VIDIEO_AUDITED) && <FormItem
            label={
              <Fragment>
                <span className="red-font">*</span>相关内容
              </Fragment>
            }
            labelLayout={{ size: 4 }}>
              <Button type="primary" hollow style={{"width":"100px","flex":"0 0 auto"}}
              onClick={() => this.toggelFeedbackList(true)}>
                选择内容
              </Button>
              {feedback === '' ? '' :
              <Fragment>
                <Tag name="feedback" value={feedback} style={{"marginLeft":"10px","maxWidth":"335px"}}
                hasBorder={false} type="secondary" closable onDelete={this.handleResetFeedback}>
                  {feedback}</Tag>
              </Fragment>
              }
            </FormItem>}
            <FormItem labelLayout={{ size: 4 }} label="上传图片" styleName="file-uploader">
              <div>
                <div>
                  <div styleName="input-wrapper">
                    <input
                      disabled={files.length > 4}
                      type="file"
                      multiple
                      accept="image/*"
                      styleName="input-file"
                      onChange={this.handleImgChange}/>
                    <span styleName={files.length > 4 ? 'label label-disabled' : 'label'}>
                      选择图片
                    </span>
                  </div>
                  <span styleName="tip">最多上传5张图片</span>
                </div>
                <ul styleName="file-list">
                  {files.map((file, index) => (
                    <li key={index}>
                      {file.loaded && (
                        <button onClick={this.handleDelete(file.key, 'files')} styleName="delete-btn">
                          <Icon type="cancel" />
                        </button>
                      )}
                      <span>
                        {file.loaded
                          ? file.url
                            ? file.name
                            : `${file.name} 上传失败`
                          : '正在上传...'}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </FormItem>
            {!(tagCode === ARTICLE_AUDITED || tagCode === VIDIEO_AUDITED) && <FormItem labelLayout={{ size: 4 }} label="上传视频" styleName="file-uploader">
              <div>
                <div>
                  <div styleName="input-wrapper">
                    <input
                      disabled={videoFiles.length > 0}
                      type="file"
                      accept="video/mkv,video/mov,video/flv,video/mpeg4,video/rm,video/rmvb,video/wmv,video/ts,video/asf,video/vob,video/dat,video/m4v,video/3gp,video/mp4,video/avi,video/quicktime"
                      styleName="input-file"
                      onChange={this.handleVideoChange}/>
                    <span styleName={videoFiles.length > 0 ? 'label label-disabled' : 'label'}>
                      选择视频
                    </span>
                  </div>
                  <span styleName="tip">{'最多上传1个视频，单个文件<10MB'}</span>
                </div>
                <ul styleName="file-list">
                  {videoFiles.map((file, index) => (
                    <li key={index}>
                      {file.loaded && (
                        <button onClick={this.handleDelete(file.key, 'videoFiles')} styleName="delete-btn">
                          <Icon type="cancel" />
                        </button>
                      )}
                      <span>
                        {file.loaded
                          ? file.url
                            ? file.name
                            : `${file.name} 上传失败`
                          : '正在上传...'}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </FormItem>}
            {!(tagCode === ARTICLE_AUDITED || tagCode === VIDIEO_AUDITED) && <FormItem labelLayout={{ size: 4 }} label="上传附件" styleName="file-uploader">
              <div style={{ width: 560, position: 'relative' }}>
                <div>
                  <div styleName="input-wrapper">
                    <input
                      disabled={appendixFiles.length > 0}
                      type="file"
                      multiple
                      accept=".docx,application/pdf,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      styleName="input-file"
                      onChange={this.handleAppendixChange}/>
                    <span styleName={appendixFiles.length > 0 ? 'label label-disabled' : 'label'}>
                      选择附件
                    </span>
                  </div>
                  <span style={{ position: 'absolute', top: 0, left: 100 }} styleName="tip">{'最多上传1个附件，单个文件<10MB，请上传.doc、.docx、.pdf、.xls、.xlsx格式的附件'}</span>
                </div>
                <ul styleName="file-list">
                  {appendixFiles.map((file, index) => (
                    <li key={index}>
                      {file.loaded && (
                        <button onClick={this.handleDelete(file.key, 'appendixFiles')} styleName="delete-btn">
                          <Icon type="cancel" />
                        </button>
                      )}
                      <span>
                        {file.loaded
                          ? file.url
                            ? file.name
                            : `${file.name} 上传失败`
                          : '正在上传...'}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </FormItem>}
            {tagCode !== PLAGIARIZE ? (
              <ValidationField
                label="相关链接"
                name="link"
                validateTrigger="onBlur"
                labelLayout={{ size: 4 }}>
                <Input placeholder="请输入相关文章的页面链接" styleName="input" />
              </ValidationField>
            ) : null}
            <ValidationField
              label="联系方式"
              name="contact"
              validateTrigger="onBlur"
              labelLayout={{ size: 4 }}>
              <Input placeholder="请输入您的手机号或邮箱地址" styleName="input" />
            </ValidationField>
            <FormItem labelLayout={{ size: 4 }}>
              <Button
                styleName="submit-btn"
                type="primary"
                disabled={
                  (isInitialized
                  || !isValid
                  || (files.length > 0 && files.find(file => !file.loaded))
                  || (videoFiles.length > 0 && videoFiles.find(file => !file.loaded))
                  || (appendixFiles.length > 0 && appendixFiles.find(file => !file.loaded))
                  || (tagCode === PLAGIARIZE && linkError)
                  || (tagCode === USER_NAME && nameError)
                  || ((tagCode === ARTICLE_AUDITED || tagCode === VIDIEO_AUDITED)&&(feedback === '')))
                  || !isLastCode
                }
                onClick={submit(this.handleCommit)}
                loading={isSubmitting}>
                提交
              </Button>
            </FormItem>
          </Col>
          <Col size="8">
            {questionList.length > 0 ? (
              <nav styleName="hot-question">
                <h1>常见问题</h1>
                <ul styleName="questions-list">
                  {questionList.map((q, index) => (
                    <li role="none" onClick={() => this.handleOpenDrawer(q)} styleName="questions-list-item" key={index}>{q.title}</li>
                  ))}
                </ul>
                <div
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    window.open(`//${window.location.host}/college.html`)
                  }}
                  styleName="more-question">其他问题或相关学习，可以访问易学院</div>
              </nav>
            ) : null}
          </Col>
        </Row>
        <Modal
        title="审核反馈"
        hasFooter={false}
        isOpen={isFeedbackListShow}
        onCancel={() => this.toggelFeedbackList(false)}>
          <Modal.Content>
            <div style={{color: '#e64646'}}>发布作品后，请耐心等待审核结果，如果发布后24小时内没有得到审核结果，请再进行反馈。</div>
            <Table columns={columns} dataSource={dataSource} hideTableTitle />
            <Pagination
            current={current}
            total={total}
            pageSize={pageSize}
            showPer={false}
            scrollToTop={false}
            prev="前一页"
            next="后一页"
            onChange={this.handlePageChange} />
            <div className="ne-modal-footer" style={{"padding": "15px 5px 0px"}}>
            <Button onClick={() => this.toggelFeedbackList(false)}>取消</Button>
            {feedbackTitle === '' ? <Button disabled>确定</Button> :
            <Button type="primary" onClick={
              () => {
                this.toggelFeedbackList(false)
                this.setState({
                  feedback: feedbackTitle,
                  feedbackId: feedbackDocId
                },() => this.setState({
                  feedbackTitle:'',
                  feedbackDocId:''
                }))
              }
            }>确定</Button>}
            </div>
          </Modal.Content>
        </Modal>
        <Drawer visible={visible} onClose={this.handleCloseDrawer}>
          <div className="question-title">{`${questionInfo.label} 常见问题`}</div>
          <div className="question-data">
            {questionList.map(item => (
              <QuestionItem current={currentQuestion} key={item.title} data={item} />
            ))}
          </div>
        </Drawer>
      </Fragment>
    );
  }
}

export default connect(
  state => ({
    common: state.common,
  }),
  dispatch =>
    bindActionCreators(
      {
        push,
      },
      dispatch,
    ),
)(
  formCreator(
    {
      tagCode: '',
      content: ''
    },
    rules,
  )(withRouter(FeedbackForm)),
);
